import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import Plans from './../components/Plans';
import utils from './../lib/utils';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    billing: state.billing,
    currentDomain: utils.getCookie('domain'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Plans);
